import { bl_applet_label_link_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AppletLabelLinkContainerModel extends BaseContainerModel {
    bl_applet_label_link: bl_applet_label_link_RowClass = new bl_applet_label_link_RowClass();
}
